import { Outlet } from 'react-router-dom';

const EventsOutlet = () => {
  return <Outlet />;
};

export default EventsOutlet;
